// src/components/App/index.js
import React, { Component } from 'react';
import {Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn} from 'material-ui/Table';
import FlatButton from 'material-ui/FlatButton';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import CompanyRow from './CompanyRow';
import AutoComplete from 'material-ui/AutoComplete';
import BaseService from '../../service/baseservice';
import {Toolbar, ToolbarGroup} from 'material-ui/Toolbar';
import CompanyEditDialog from './CompanyEditDialog';
import UserSelectField from '../shared/UserSelectField';
import Checkbox from 'material-ui/Checkbox';

var CompanyService = require('../../service/companies');
var Auth = require('../../service/auth');

import './style.css';

import AdminHeader from '../AdminHeader';

export default class FrontPage extends Component {
  emptyCompany() {
    return {
          marketingName: "",
          officialName:"",
          streetAddress:"",
          companyContacts: [],
          decisionHistory: []
      };
  }

  state = {
    dialogOpen: false,
    segment: "ALL",
    filters: {'from': 0, 'to': 50},
    selectedMunicipality: "ALL",
    selectedCategory: null,
    selectedIndustry: null,
    selectedSeller: "NO_SELLER",
    selectedTargetSeller: null, // for assigning seller to companies
    selectedCompanies: [],
    total: 0,
    companies: [],
    selectedCompany: this.emptyCompany(),
    dataUpdated: null,
    fetchedSellerCompaniesOnce: false,
    additionalFlags: []
  };

  additionalFlagOptions = [
    {value:"isAffa", title: "Äffä"},
    {value:"isNotContinuousContract", title:"Määräaikainen sopimus"},
    {value:"purchacedByCompetitorPressed", title: "Kilpailijaosto, painettu"},
    {value:"purchacedByCompetitorDigital", title: "Kilpailijaosto (sähköinen)"},
    {value:"hasNoGoogleProfile", title: "Ei Google-profiilia"},
    {value:"hasNoWebsite", title: "Ei verkkosivuja"},
    {value:"hasCancelled", title: "Peruuttanut"},
    {value:"isBurned", title: "Poltettu"},
    {value:"hasFinished", title: "Lopettanut"},
    {value:"soldAlueluettelo", title: "Myyty Alueluettelo"},
    {value:"soldGoogleProfile", title: "Myyty Google-profiili"},
    {value:"soldGoogleProfileUpdate", title: "Myyty Google-profiilin päivitys"},
    {value:"soldFacebook", title: "Myyty Facebook"},
    {value:"soldAdWords", title: "Myyty Ad-Words"},
    {value:"soldWebsite", title: "Myyty kotisivut"},
    {value:"hasDecisions", title: "Päätetty"},
    {value:"hasNoDecisions", title: "Ei päätetty"}
  ];

  dataUpdated(data) {
    this.setState({dataUpdated: new Date()});

    if (Auth.userData && !Auth.userData.isAdmin && !this.fetchedSellerCompaniesOnce) {
      this.setState({filters: {'from': 0, 'to': 100}, selectedSeller: Auth.userData}, state => {
        this.fetchCompanies();
      });
    }
  }

  componentDidMount() {
    BaseService.addListener(this.dataUpdated.bind(this));

    if (Auth.userData && !Auth.userData.isAdmin && !this.fetchedSellerCompaniesOnce) {
      this.setState({filters: {'from': 0, 'to': 100}, selectedSeller: Auth.userData}, state => {
        this.fetchCompanies();
      });
    }
  }

  onSearch = () => {
    this.setState({companies:[], total: 0, filter: {'from':0, 'to': 10}}, function() {
      this.fetchCompanies();
    });
  }

  onSegmentChanged = (event, index, value) => {
    this.setState({segment:value});
  }

  onAdditionalInfoChanged = (event, index, values) => {
    this.setState({additionalFlags:values});
  }

  onMunicipalityChanged = (chosenRequest, index) => {
    if (index === 0) {
      this.setState({selectedMunicipality: "ALL"});
    } {
      var municipality = BaseService.fetchedData.municipalities[index-1];
      this.setState({selectedMunicipality: municipality});
    }
  }

  onSelectedRow = (selected) => {
    var selectedCompanies = [];
      if (selected == "all") {
        for (var i = 0; i < this.state.companies.length; i++) {
          selectedCompanies.push(i);
        }
      } else if (selected == "none") {
        selectedCompanies = [];
      } else {
        selectedCompanies = selected;
    }

    setTimeout(function() {
      this.setState({'selectedCompanies': selectedCompanies});
    }.bind(this), 0);
   }

   onAssignSeller = () => {
     var companyIds = this.state.selectedCompanies.map(companyIdx => this.state.companies[companyIdx]._id);
     CompanyService.assignSellerToCompanies(this.state.selectedTargetSeller, companyIds).then(() => {
       this.fetchCompanies();
       this.setState({selectedTargetSeller: null, selectedCompanies: []});
     });
   }

  onCategoryChanged = (chosenRequest, index) => {
    this.setState({selectedCategory: BaseService.fetchedData.categories[index]});
  }

  onIndustryChanged = (chosenRequest, index) => {
    this.setState({selectedIndustry: BaseService.fetchedData.industries[index]})
  }

  loadMoreCompanies() {
    var from = this.state.filters.from;
    var to = this.state.filters.to + 50;
    this.setState({filters: {'from': from, 'to': to}}, () => this.fetchCompanies());
  }

  fetchCompanies() {
    var params = {};

    params.from = this.state.filters.from;
    params.to = this.state.filters.to;
    params.segment = this.state.segment;

    if (this.state.selectedSeller && this.state.selectedSeller != null && this.state.selectedSeller._id) {
      params.seller = this.state.selectedSeller._id;
    } else if (this.state.selectedSeller && this.state.selectedSeller != null && this.state.selectedSeller == "NO_SELLER"){
      params.seller = "NO_SELLER";
    } else {
      delete params.seller;
    }

    this.state.additionalFlags.forEach(flag => {
      if (flag == "isNotContinuousContract") {
        params.isContinuousContract = false;
      } else if (flag == "hasNoDecisions") {
        params.hasDecisions = false;
      } else {
        params[flag] = true;
      }
    });

    if (this.state.selectedMunicipality && this.state.selectedMunicipality != "ALL") {
      params.municipality = this.state.selectedMunicipality.name;
    } else {
      delete params.municipality;
    }

    if (this.state.selectedCategory != null) {
      params.mainCategory = this.state.selectedCategory._id;
    } else {
      delete params.mainCategory;
    }

    if (this.state.selectedIndustry != null) {
      params.industry = this.state.selectedIndustry._id;
    }

    console.log(JSON.stringify(params));

    CompanyService.findCompanies(params).then(result => {
      this.setState({companies: result.companies, total: result.count});
    }).catch(error => {});
  }

  onSellerSelected(seller) {
    this.setState({selectedSeller: seller});
  }

  onTargetSellerSelected(seller) {
    this.setState({selectedTargetSeller: seller });
  }

  onSellerNoSellerSelected() {
    this.setState({selectedSeller: "NO_SELLER"});
  }

  onCompanySelected(selected) {
    let newState = {
      dialogOpen:true,
      companyIndex: selected,
      selectedCompany: this.state.companies[selected]
    };

    this.setState(newState);
  }

  onCompanyProgressToggled(toggled) {
    var state = this.state;
    const company = state.companies[toggled];
    company.isInProgressForSeller = !company.isInProgressForSeller;
    company.isInProgressForSellerInProgress = true;
    this.setState(state);

    CompanyService.editCompany(company).then(editedCompany => {
      var state = this.state;
      const company = state.companies[toggled];
      company.isInProgressForSellerInProgress = false;
      this.setState(state);
    });
  }

  createCompany() {
    this.setState({dialogOpen: true, selectedCompany: this.emptyCompany()});
  }

  handleClose() {
    this.setState({dialogOpen: false, companies: CompanyService.fetchedCompanies.companies, total: CompanyService.fetchedCompanies.total});
  }

  renderRow(company) {
    var selectedIndex = this.state.companies.indexOf(company);
    var selected = Auth.userData.isAdmin && this.state.selectedCompanies.includes(selectedIndex);
    var segment = '';

    if (company.contractValue > 14) {
      segment = 'A - ';
    } else if (company.contractValue > 0) {
      segment = 'B - ';
    }

    var secondaryInfo = '';
    var sellerName = '';
    var assignedDate = '';

    if (company.seller && company.seller != null) {
      sellerName = company.seller.fullName;
    }

    if (company.assignedToSeller && company.assignedToSeller != null) {
      var userAssignedDate = new Date(company.assignedToSeller);
      assignedDate = userAssignedDate.getDate() + "." + (userAssignedDate.getMonth()+1) + "." + userAssignedDate.getFullYear();
    }

    if (Auth.userData.isAdmin) {
      secondaryInfo = <span>{sellerName} <br/> {assignedDate}</span>;
    } else {
      secondaryInfo = assignedDate;
    }

    let lastDecisionDiv = null;
    if (company.decisionHistory.length > 0) {
      var lastDecision = company.decisionHistory
              .filter(a => (a.type != undefined))
              .sort((a,b) =>  new Date(b.date) - new Date(a.date))[0];

      if (lastDecision) {
        var date = new Date(lastDecision.date);

        lastDecisionDiv = <div>
          <span>{lastDecision.type.name} {date.getDate() + "." + (date.getMonth()+1) + "." + date.getFullYear()} <br/>
          {lastDecision.seller ? lastDecision.seller.fullName : ''}</span>
        </div>;
      } else {
        lastDecisionDiv = <div>Ei päätöksiä.</div>
      }
    }  else {
      lastDecisionDiv = <div>Ei päätöksiä.</div>
    }

    let sellerInProgressRow = null;
    if (!Auth.userData.isAdmin) {
      sellerInProgressRow = <TableRowColumn style={{width:"30px"}}><Checkbox disabled={company.isInProgressForSellerInProgress} checked={company.isInProgressForSeller} onCheck={(component) => this.onCompanyProgressToggled(selectedIndex, component)}/></TableRowColumn>;
    }

    const notPublishedStyle = { backgroundColor: 'yellow', opacity: '0.5' }
    
    const style = company.isPublished ? {} : notPublishedStyle

    return <TableRow key={company._id} selected={selected} selectable={Auth.userData.isAdmin} style={style}>
      <TableRowColumn style={{whiteSpace:'normal'}}>
        {company.marketingName ? company.marketingName : company.officialName}<br/>
      <span style={{fontSize:"10px", color:"grey"}}>{company.marketingName ? company.officialName : ''}</span>
      </TableRowColumn>
      <TableRowColumn style={{width: "90px", whiteSpace: 'normal'}}>
        {segment}
        {(company.contractValue && company.contractValue > 0) ? company.contractValue + " €" : "Ei ostoa"}<br/>
        {secondaryInfo}
      </TableRowColumn>
      <TableRowColumn style={{width: "90px", whiteSpace: 'normal'}}>
        {lastDecisionDiv}
      </TableRowColumn>
      <TableRowColumn style={{whiteSpace:'normal'}}>
        {company.industry ? company.industry.name : '-'}<br/>
        <span style={{fontSize:"10px", color:"grey"}}>{company.mainCategory ? company.mainCategory.name : ''}</span>
      </TableRowColumn>
      <TableRowColumn style={{whiteSpace:'normal', width:'120px'}}>
        {company.city ? company.city.name : ''}<br/>
        {company.municipality}
      </TableRowColumn>
      <TableRowColumn style={{whiteSpace:'normal', width: '180px'}}>
        {company.phoneNumber}<br/>
        {company.emailAddress}
      </TableRowColumn>
      {sellerInProgressRow}
      <TableRowColumn style={{whiteSpace:'normal', width:'90px'}}>
        <FlatButton label="Muokkaa" onTouchTap={() => this.onCompanySelected(selectedIndex)}/>
      </TableRowColumn>
    </TableRow>;
  }

  renderTable(rows) {
    let sellerInProgressRow = null;
    if (!Auth.userData.isAdmin) {
      sellerInProgressRow = <TableHeaderColumn style={{width:"30px"}}>Kesken?</TableHeaderColumn>;
    }

    return <Table
      multiSelectable={Auth.userData.isAdmin}
      onRowSelection={(rows) => this.onSelectedRow(rows)}>
      <TableHeader
        displaySelectAll={Auth.userData.isAdmin}
        adjustForCheckbox={Auth.userData.isAdmin}
        enableSelectAll={Auth.userData.isAdmin}>
        <TableRow>
          <TableHeaderColumn>Nimi</TableHeaderColumn>
          <TableHeaderColumn style={{width:"90px"}}>Segmentti & myyjä</TableHeaderColumn>
          <TableHeaderColumn style={{whiteSpace:'normal', width:"90px"}}>Edellinen päätös</TableHeaderColumn>
          <TableHeaderColumn style={{whiteSpace:'normal'}}>Toimiala</TableHeaderColumn>
          <TableHeaderColumn style={{whiteSpace:'normal', width:'120px'}}>Paikkakunta</TableHeaderColumn>
          <TableHeaderColumn style={{whiteSpace:'normal', width: '180px'}}>Yhteystiedot</TableHeaderColumn>
          {sellerInProgressRow}
          <TableHeaderColumn style={{whiteSpace:'normal', width:'90px'}}><b style={{color: 'black'}}>{this.state.total} osumaa</b></TableHeaderColumn>
        </TableRow>
      </TableHeader>
      <TableBody displayRowCheckbox={Auth.userData.isAdmin}
        stripedRows={false}
        deselectOnClickaway={false}>
        {rows}
      </TableBody>
    </Table>;
  }

  renderSellerToolbar() {
    var length = this.state.selectedCompanies.length;
    var countString = length > 1 ? length+" yritystä valittu. ->" : "Yksi yritys valittu. ->";
    return <Toolbar style={{backgroundColor: 'white', borderTop: '3px orange solid', position:'fixed', bottom: 0, left: 0, right: 0}}>
      <ToolbarGroup>
        <p>{countString}</p>
        <UserSelectField
          style={{paddingTop: 0, marginTop: 0, marginLeft:'20px'}}
          hintText="Valitse myyjä"
          emptyText="Valitse myyjä"
          onUserSelected={(user) => this.onTargetSellerSelected(user)}
          value={this.state.selectedTargetSeller ? this.state.selectedTargetSeller._id : null} />
        <FlatButton label="Aseta myyjä" disabled={!this.state.selectedTargetSeller || this.state.selectedTargetSeller == null} primary={true} onTouchTap={() => this.onAssignSeller() }/>
      </ToolbarGroup>
    </Toolbar>;
  }

  municipalitySelector() {
    var municipalityItems = BaseService.fetchedData.municipalities.map(municipality => {
      return <MenuItem key={municipality._id} value={municipality.name} primaryText={municipality.officialName} />
    });
    var selectedMunicipality = this.state.selectedMunicipality ? this.state.selectedMunicipality.name : null;

    return <SelectField
          floatingLabelText="Valitse alue"
          onChange={this.onMunicipalityChanged}
          value={selectedMunicipality}
          style={{width:'190px'}}>
          <MenuItem value="ALL" primaryText="Kaikki alueet"/>
          {municipalityItems}
        </SelectField>;
  }

  renderSearchToolbar() {
    if (Auth.userData && Auth.userData.isAdmin) {
      return this.renderAdminSearchToolbar();
    } else {
      return this.renderSellerSearchToolbar();
    }
  }

  renderSellerSearchToolbar() {
    console.log("SellerToolbar");
    return <Toolbar style={{padding:"45px", backgroundColor: "white", backgroundColor: "white"}}>
      <ToolbarGroup firstChild={true}>
        {this.municipalitySelector()}
        <FlatButton label="Hae" primary={true} onClick={this.onSearch}/>
      </ToolbarGroup>
    </Toolbar>;
  }

  renderAdminSearchToolbar() {
    console.log("AdminToolbar");
    var selectedSeller = null;

    if (this.state.selectedSeller && this.state.selectedSeller._id) {
      selectedSeller = this.state.selectedSeller._id;
    } else if (this.state.selectedSeller == "NO_SELLER") {
      selectedSeller = "NO_SELLER";
    }

    var additionalMenuItems =  this.additionalFlagOptions.map(option => {
      return <MenuItem value={option.value}
                        key={option.value}
                  primaryText={option.title}
                  checked={this.state.additionalFlags.includes(option.value)}/>
              });

    var adminOnlyVisibility = (Auth.userData && Auth.userData.isAdmin) ? 'visible' : 'none';

    return <Toolbar style={{padding:"45px", backgroundColor: "white", backgroundColor: "white"}}>
      <ToolbarGroup firstChild={true}>
        {this.municipalitySelector()}
        {/* <AutoComplete
          style={{marginLeft: '15px'}}
          dataSource={BaseService.fetchedData.categories}
          dataSourceConfig={{text: 'name', value: '_id'}}
          filter={AutoComplete.caseInsensitiveFilter}
          floatingLabelText="Valitse toimiala"
          listStyle={{width:'100%'}}
          hintText="Kaikki toimialat"
          maxSearchResults={10}
          onNewRequest={this.onCategoryChanged}
        /> */}
        <AutoComplete
          style={{marginLeft: '15px'}}
          dataSource={BaseService.fetchedData.industries}
          dataSourceConfig={{text: 'name', value: '_id'}}
          filter={AutoComplete.caseInsensitiveFilter}
          floatingLabelText="Valitse toimiala"
          listStyle={{width:'100%'}}
          hintText="Kaikki toimialat"
          maxSearchResults={10}
          onNewRequest={this.onIndustryChanged}
        />
        <SelectField
          style={{marginLeft: '15px'}}
          floatingLabelText="Segmentti"
          onChange={this.onSegmentChanged}
          value={this.state.segment}
          style={{width:'180px', marginLeft: '5px'}}>
          <MenuItem value={"ALL"} primaryText="Kaikki" />
          <MenuItem value={"A"} primaryText="A - Ostaneet" />
          <MenuItem value={"B"} primaryText="B - Dummit" />
          <MenuItem value={"C"} primaryText="C - Ei-ostaneet" />
          <MenuItem value={"D"} primaryText="D - Poltetut tai peruutetut" />
        </SelectField>
        <SelectField
          multiple={true}
          floatingLabelText="Lisävalinnat"
          onChange={this.onAdditionalInfoChanged}
          value={this.state.additionalFlags}
          maxHeight={650}
          style={{width:'260px', marginLeft: '5px'}}>
          {additionalMenuItems}
        </SelectField>
        <UserSelectField
          style={{width:'160px', marginLeft:'5px'}}
          floatingLabelText="Myyjä"
          onUserSelected={(user) => this.onSellerSelected(user)}
          showNoSellerItem={true}
          onAllUsersSelected={() => this.onSellerNoSellerSelected()}
          value={selectedSeller} />

      </ToolbarGroup>
      <ToolbarGroup lastChild={true}>
        <FlatButton label="Hae" primary={true} onClick={this.onSearch}/>
      </ToolbarGroup>
    </Toolbar>;
  }

  render() {
    var rows = this.state.companies.map(company => {
      return this.renderRow(company);
    });

    var left = this.state.total - this.state.companies.length;
    var more = Math.min(left, 50);
    var loadMoreButton = left > 0 ?  <FlatButton style={{width:'100%', marginTop:'20px', marginBottom: '100px'}} label={"Lataa " + more + " lisää"} onClick={() => this.loadMoreCompanies()}></FlatButton> : '';
    var table = this.state.companies.length > 0 ? this.renderTable(rows) : '';
    var selectSellerToolbar = (this.state.selectedCompanies.length > 0 && Auth.userData.isAdmin) ? this.renderSellerToolbar() : '';
    var searchToolbar = this.renderSearchToolbar();

    return (
      <div>
        <AdminHeader selected="companies" />
        <Toolbar style={{backgroundColor: 'rgba(232, 232, 232, 1)'}}>
          <ToolbarGroup>
              <FlatButton label="Luo uusi yritys"
                          primary={true}
                          style={{marginLeft: "10px"}}
                          onTouchTap={() => this.createCompany()}
                          />
          </ToolbarGroup>
        </Toolbar>
        <br/>
        <div className="main-container">
          {searchToolbar}
          {table}
          {loadMoreButton}
          {selectSellerToolbar}
        </div>

        <CompanyEditDialog
          enabled={this.state.dialogOpen}
          handleClose={() => this.handleClose()}
          company={this.state.selectedCompany}/>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/FrontPage/FrontPage.js